import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONFIGURATION } from '../app.constants';
import { User, CookieOptionsArgs } from '../models';
import { Router, ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NgxPermissionsService } from 'ngx-permissions';

declare var config: any;
declare var window: any;
@Injectable({ providedIn: 'root' })


export class AuthenticationService {
    returnUrl: string;
    private currentUserSubject: BehaviorSubject<User>;
    public topMenuBar: EventEmitter<boolean>;
    public dynamicOutClick: EventEmitter<string>;
    private userURL = CONFIGURATION.baseUrls.UserURL;
    public currentUser: Observable<User>;
       _cookieOptionsArgs: CookieOptionsArgs;
    constructor(private http: HttpClient,
        private route: ActivatedRoute, 
        private permissionsService: NgxPermissionsService
    ) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this._cookieOptionsArgs = this.initializeCookieOptions(); 
        this.topMenuBar = new EventEmitter<boolean>();
        this.dynamicOutClick = new EventEmitter<string>();
        
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    initializeCookieOptions(): CookieOptionsArgs {
        return {
            domain: window.location.hostname,
            path: CONFIGURATION.constants.CookieStoragepath,
            secure: false,
            expires: this.expiryDate()
        };
    }
    expiryDate(): Date {
        var _date = new Date();
        return new Date(_date.setMinutes(_date.getMinutes() + CONFIGURATION.constants.CookieExpiryTime));
    }
    login(username: string, password: string) {
         
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        headers.append('Accept', 'application/json');

        return this.http.post<any>(CONFIGURATION.baseUrls.authenticationUrl,
            CONFIGURATION.baseUrls.authenticationBody.replace('%%username%%', username).replace('%%password%%', password),
            { headers: headers })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.access_token) {                
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                    const helper = new JwtHelperService();
                    const decodedToken = helper.decodeToken(user.access_token);
                    localStorage.setItem('user-roles', decodedToken.role);
                    // var role = new Array(decodedToken.role)
                    if (decodedToken) {
                        this.writeCookie(CONFIGURATION.constants.CookieName, user.access_token);
                        if (Array.isArray(decodedToken.role)) {
                            this.permissionsService.loadPermissions(decodedToken.role);
                        }
                        else {
                            this.permissionsService.loadPermissions([decodedToken.role]);
                        }
                    }

                }

                return user;
            }));
    }
    // SetCookie(key: string, value: Object, options?: CookieOptionsArgs): void {
    //     this.cookieService.set(key, value, this._cookieOptionsArgs);
    // }

    //write new cookie
    writeCookie = function (name, data) {
        //write cookie for one day  it works all sub domains
        var expireTime = this.expiryDate();
        document.cookie = escape(name) + "=" + escape(data) + ';expires=' + expireTime.toGMTString() + ';path=/' + ";domain=" + window.location.hostname;
    }
    getUserByUserId(id): Observable<any> {
        const url = this.userURL + 'user/GetUserById?guid=' + id;
        return this.http.get(url);

    }

    logout(user) {
        var mainCookie = this.getCookByName(CONFIGURATION.constants.CookieName);
        // remove user from local storage to log user out
        document.cookie = escape(CONFIGURATION.constants.CookieName) + "=" + escape(user) + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/' + ';domain=' + window.location.hostname;
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
    getAuthorizationToken() {
        //cookie is cookie logic. 
        if (document.cookie != "" && document.cookie != undefined) {
            var curentCookie = document.cookie;
            if (curentCookie.indexOf(CONFIGURATION.constants.CookieName) == -1) {
                return null;
            }
            else {
                var mainCookie = this.getCookByName(CONFIGURATION.constants.CookieName);
                if (mainCookie != undefined && mainCookie != null) {
                    return mainCookie;
                }
                else {
                    return null;
                }
            }
        }
        else {
            return null;
        }

    }

    getCookByName(name) {
        var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value != null) ? unescape(value[1]) : null;
    }
    VerifyToken(UserGuid, PwdGuid) {
        const url = CONFIGURATION.baseUrls.UserURL + 'User/VerifyToken?UserGuid=' + UserGuid + '&PwdGuid=' + PwdGuid;
        return this.http.get(url);           
    }
    ResetPassword = (userguId: string, newPswd: string) => {
        const url = `${CONFIGURATION.baseUrls.UserURL + 'user/ResetPassword?userGuid='}${userguId}` + '&newPswd=' + newPswd;
        return this.http.get(url);        
    }
    UsernameCheck(username,URL) {
        const url = CONFIGURATION.baseUrls.UserURL + 'user/GenerateToken?userName=' + username + '&URL=' + URL;
        return this.http.get(url);          
    }
    extractData = (response: Response) => {
        let body = response.json();
        return body;
    }

    handleError = (error: Response | any): Observable<any> => {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}